let set_active_color=() => {
	let active_color=document.querySelector('[data-active-color]');

	if (active_color) {
		let active_color_text=active_color.getAttribute('data-active-color');
		let active_swatch=document.querySelector('.product-color.active');

		let swatches_container = active_swatch.closest('.product__colors');

		let label=swatches_container.previousElementSibling;
		
		label.innerHTML+=`: ${active_color_text}`;



	}
}

set_active_color();
window.addEventListener('click',async (event) => {






	let {target} = event;






	if(target.classList.contains('members-banner') || target.closest('.members-banner')) {
		let bubble= document.querySelector('.bubble-container');
		bubble.classList.add('active');

	} else {
		let bubble= document.querySelector('.bubble-container');

		bubble.classList.remove('active');
	}


	if(target.classList.contains('size-guide-btn')) {
		document.querySelector('button[id*="ProductsPopup"]').dispatchEvent(new Event('click'));
	}

	if(target.classList.contains('product__media__badge') || target.closest('.product__media__badge') || target.classList.contains('manufacture-info-icon') || target.closest('.manufacture-info-icon')  ) {
		event.preventDefault();

		if(target.closest('.manufacture-meta')) {
			let manufacturer_info = document.querySelector('.manufacture-meta .manufacturer_info');
			manufacturer_info.classList.toggle('open');
		}
		
		
	
	} else {
			let manufacturer_info = document.querySelector('.manufacture-meta .manufacturer_info.open');
			if(manufacturer_info) {
				manufacturer_info.classList.remove('open'); 
			} 
			
	}

	if(target.classList.contains('product-form__submit')) {
		let url = new URL(window.location.href); 
		url.searchParams.set('sections','announcement-bar');

		setTimeout(async () => {
			let announcementSectionResponse = await fetch(url.toString());
			let getAnnouncementSectionData = await announcementSectionResponse.json();
			let announcementElement = new DOMParser().parseFromString(getAnnouncementSectionData['announcement-bar'], 'text/html').body.childNodes[0];
		
			let announcementOld = document.querySelector('.membership_benefit');
			let announcementNew = announcementElement.querySelector('.membership_benefit');

			announcementNew.classList.remove('v2');


			if(announcementOld) {
				announcementOld.remove();
			}

			if(announcementNew) {
				document.body.append(announcementNew);
			}

		
		
		}, 300);


	}

	if (target.id=='garment_measurements') {
		let fit_notes_details=document.querySelector('#fit-notes').parentElement;

		fit_notes_details.scrollIntoView({behavior:'smooth'})

		let summary=fit_notes_details.querySelector('summary');
		summary.click();
		ga('send','event','PDP','Button Click','Garment Measurments');
}
	if(target.name == 'Size') {
	setTimeout(async () => {
	let url = new URL(window.location.href); 
		url.searchParams.set('sections','product-color-swatchers');
		
	let getMainProductSectionResponse = await fetch(url.toString());
	let getMainProductSectionData = await getMainProductSectionResponse.json();
	let element = new DOMParser().parseFromString(getMainProductSectionData['product-color-swatchers'], 'text/html').body.childNodes[0];
		let product_color_class='.product_color_variants_container';
		let add_to_cart_selector='.product-form__submit';
		let variant_info_selector="#variant_info";
		let old_add_to_cart_btn=document.querySelector(add_to_cart_selector);
		let add_to_cart_btn=element.querySelector(add_to_cart_selector);

		let variant_info=element.querySelector(variant_info_selector);
		let variant_info_old=document.querySelector(variant_info_selector);

	let product_colors_old = document.querySelector(product_color_class);
	let product_color_new=element.querySelector(product_color_class);
		variant_info_old.insertAdjacentElement('beforebegin',variant_info);
		variant_info_old.remove(); 
		old_add_to_cart_btn.insertAdjacentElement('beforebegin',add_to_cart_btn);
		old_add_to_cart_btn.remove(); 
	product_colors_old.insertAdjacentElement('beforebegin', product_color_new);
		product_colors_old.remove();
		
		set_active_color();
	}, 200);
		





		
	}



	if (target.classList.contains('size_guide_set')) {
		document.querySelector(".product-popup-modal__button").click();
	}



	 

	if (target.classList.contains('product_set_option') && !target.classList.contains('not-available') ) {		
		let set=target.closest('.product_set');

	
		let current_active=set.querySelector('.active');

		if (current_active) {
			current_active.classList.remove('active');
		}


		target.classList.add('active');

		let all_sets=document.querySelectorAll('.product_set');

		let is_size_selected=[...all_sets].every(set => set.querySelector('.active'));
		let add_to_cart_btn=document.querySelector('.add_to_cart_sets');

		if (is_size_selected) {
			
			add_to_cart_btn.innerHTML='Add To Cart';

			add_to_cart_btn.setAttribute('data-available-to-add',true);

		} else {
			add_to_cart_btn.innerHTML='Select Size';
		}



		

	}


	if(target.name == 'add') {
		

		let cart_count = document.querySelector('.cart-count-bubble');
		if(!cart_count) {
			window.membership_pop_up = true;  
			document.querySelector('body').setAttribute('hide-cart-notification', true);

			let startTime= new Date().getTime();
			let pop_up_interval = setInterval(() => {

				let currentTime = new Date().getTime();


				if(localStorage.getItem('ms_pop_up')) {
					let pop_up = document.querySelector('.membership_pop_up');
			
					if(pop_up ) { 
						pop_up.setAttribute('visible', true);  
					} else {
						document.querySelector('body').removeAttribute('hide-cart-notification'); 
					}
					

					clearInterval(pop_up_interval);
				}


				if(currentTime - startTime >= 1500) { 
					document.querySelector('body').removeAttribute('hide-cart-notification');
				}
	
				
	
			}, 100);
		}



	
		
	}
	function createRandomString(length) {
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let result = "";
		const randomArray = new Uint8Array(length);
		crypto.getRandomValues(randomArray);
		randomArray.forEach((number) => {
		  result += chars[number % chars.length];
		});
		return result;
	  }
	  



	if (target.hasAttribute('data-available-to-add')) {

		let product_sets=document.querySelectorAll('.product_set');
		let random_str = createRandomString(5);

		let items=[];
		for (let i=0;i<product_sets.length;i++) {
			let current_product_set=product_sets[i];
			let active_variant=current_product_set.querySelector('.active');
			let set=current_product_set.getAttribute('data-set');
		

			let first_available_set=false;

			if (i==0) {
				first_available_set=true;
			}

			let variant_id=active_variant.getAttribute('data-variant-id');

			let item={
				'id': Number(variant_id),
				'quantity': 1,
				'properties': {
					set: set + '!?' + random_str
				}
			};

			if (first_available_set) {
					item['properties']['is_main'] = true
			}

			
			items.push(item);
		}

  let formData = {
				'items': items
		};
		
		
			fetch(window.Shopify.routes.root + 'cart/add.js', {
					method: 'POST',
					headers: {
							'Content-Type': 'application/json'
					},
					body: JSON.stringify(formData)
			})
			.then(response => {
					return response.json();
			}).then(data => {
			
				window.location.href='/cart';
			})
			.catch((error) => {
					console.error('Error:', error);
			}); 
		
			
		console.log('available to add');
	}
});


let start_find_visitor_interval = Date.now();


let find_visitor_count_interval = setInterval(() => {

let current_time = Date.now();


		let visitor_counter = document.querySelector('[class*="visitor-counter-content"]');

		if(visitor_counter) {
				clearInterval(find_visitor_count_interval);
				let numbers = document.querySelectorAll('.light-count');
				let number_of_visitors = [...numbers].map(number => number.innerHTML).join('');
				

				if(Number(number_of_visitors) < 10) {
						visitor_counter.style.display = 'none';
				}


				if(current_time - start_find_visitor_interval > 4000) {
						clearInterval(find_visitor_count_interval);
				}
			
			
			
			let add_sets_btn=document.querySelector('button.add_to_cart_sets');

			if(add_sets_btn) {
				add_sets_btn.insertAdjacentElement('afterend',visitor_counter);
			}


			

		}
}, 100);






let start_looking_people_interval= Date.now();
let looking_people_interval = setInterval(() => {
	let element = document.querySelector('.appRoom-visitor-counter span');

	let now = Date.now();
	let container = document.querySelector('.looking_at_product');

	if(element && container) {

		let count = document.querySelector('#dynamicvisitor_count');
	

		container.innerHTML = element.innerHTML;

		clearInterval(looking_people_interval);
		




	let add_sets_btn=document.querySelector('button.add_to_cart_sets');

	if(add_sets_btn) {
		add_sets_btn.insertAdjacentElement('afterend',container); 
	}


	if(Number(count.innerHTML) < 10){ 
		container.style.display = 'none';
	}

}


	if(now - start_looking_people_interval > 4000) {
		clearInterval(looking_people_interval);
	}
}, 100);




let info_button = document.querySelector('.manufacture-meta .manufacture-info-icon');


if(info_button) {
	info_button.addEventListener('mouseenter', (event) => {


		let manufacturer_info = document.querySelector('.manufacture-meta .manufacturer_info');
		manufacturer_info.classList.add('open');  
	});
}

